import React from "react";
import "../style/ProjectDetails.css";

const ProjectDetails = ({ project, goBack }) => {
    const { gameTitle, gameDescription, screenshots, videoUrl } = project;

    return (
        <div className="project-details-container">
            <button className="project-details-go-back-button" onClick={goBack}>Go Back</button>
            <h1 className="project-details-title">{gameTitle}</h1>
            <h2 className="project-details-section-title">Full Description</h2>
            <p className="project-details-description">{gameDescription}</p>
            <h2 className="project-details-section-title">Screenshots</h2>
            <div className="project-details-screenshots">
                {screenshots && Array.isArray(screenshots) ? (
                    screenshots.map((screenshot, index) => (
                        <img
                            key={index}
                            className="project-details-screenshot"
                            src={screenshot}
                            alt={`Screenshot ${index + 1}`}
                        />
                    ))
                ) : (
                    <p>No screenshots available</p>
                )}
            </div>
            <h2 className="project-details-section-title">Gameplay Video</h2>
            <div className="project-details-video">
                <iframe
                    width="560"
                    height="315"
                    src={videoUrl}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                ></iframe>
            </div>
        </div>
    );
};

export default ProjectDetails;